export default {
    Get: {
        TASK_MODEL: 'getTaskModel',
        TASK_DETAIL_MODEL: 'getTaskDetailModel'
    },
    Set: {
        DEEP_CLONE: 'deepClone',
        INSERT_TASK: 'insertTask',
        ORIGIN_TASK_MODEL: 'setOriginTaskModel',
        TASK_MODEL: 'setTaskModel',
        TASK_DETAIL_MODEL: 'setTaskDetailModel',
        UPDATE_TASK: 'updateTask',
        DELETE_TASK: 'deleteTask',
        PROPERTY_OF_MODEL: "setPropertyOfModel",
        CACHE_BEFORE_LEASE: "setCacheBeforeLease",
        SET_IS_SAVING: 'setIsSaving'
    }
  };